import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunityPolicyDto } from 'src/app/dtos/community-policy.dto';
import { CommunityPolicy } from 'src/app/models/community-policy';

@Injectable({
    providedIn: 'root',
})
export class CommunityPolicyResourceService {
    private baseUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'community-policies/current'
        );
    }

    getCommunityPolicy(): Observable<CommunityPolicy> {
        return this.http
            .get<CommunityPolicyDto>(this.baseUrl)
            .pipe(map((dto) => new CommunityPolicy(dto)));
    }
}
